import React from "react";
import ReactDOM from "react-dom";
import { Formik, Form, Field } from "formik";
import { ApiService } from "../../../../services/ApiService";
import DatePicker from "react-datepicker";

export default function EditassetModal({
  closeModal,
  users,
  offices,
  assetscategories,
  alert,
  getAllAssets,
  value,
}) {
  const Offices = {
    frontOffice: "front office",
    middleOffice: "middle office",
    backOffice: "back office",
  };

  let frontOfficeUser = users.filter(
    (user) => user.office && user.office.toLowerCase() === Offices.frontOffice
  );

  let middleOfficeUser = users.filter(
    (user) => user.office && user.office.toLowerCase() === Offices.middleOffice
  );
  let backOfficeUsers = users.filter(
    (user) => user.office && user.office.toLowerCase() === Offices.backOffice
  );

  return (
    <React.Fragment>
      {/* <h4 style={{ color: "#000" }}>Edit Office Asset</h4> */}
      <Formik
        initialValues={{
          name: value.name,
          description: value.description,
          category_id: value.asset_category,
          price: value.price,
          user_id: value.beneficiary,
          office_id: value.office,
          date_acquired: new Date(value.date_acquired),
          id: value.id,
        }}
        onSubmit={(values, { setSubmitting }) => {
          // if (!values.category_id || !values.description)
          //   return alert.error("Fields are required");
          ApiService.post(`assets/edit-asset/${value.id}`, values).then(
            (res) => {
              if (res.data.type === false) {
                alert.error(res.data.msg);
              } else if (res.data.type === true) {
                alert.success(res.data.msg);
                getAllAssets();
                closeModal();
              }
            }
          );
        }}
      >
        {({
          handleSubmit,
          values,
          isSubmitting,
          setFieldValue,
          handleChange,
        }) => (
          <Form>
            <div className="form-group">
              <label>
                {" "}
                Name <span className="text-danger"> * </span>{" "}
              </label>
              <Field
                type="text"
                className="form-control"
                id="name"
                name="name"
                placeholder="Assest Name"
                autoComplete="off"
                required
              />
            </div>
            <div className="form-group">
              <label>
                {" "}
                Asset Description <span className="text-danger"> * </span>
              </label>
              <Field
                type="text"
                className="form-control"
                id="description"
                name="description"
                placeholder="Asset Description"
                autoComplete="off"
                required
              />
            </div>

            <div className="form-group">
              <label>
                {" "}
                Asset category<span className="text-danger"> * </span>
              </label>
              <select
                type="text"
                className="form-control"
                id="asset_category"
                name="category_id"
                onChange={handleChange}
                value={values.category_id}
                required
              >
                <option value="">--Select Category--</option>

                {assetscategories.map((category, i) => (
                  <option value={category.id} key={i}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>
                {" "}
                Date Acquired <span className="text-danger"> * </span>
              </label>
              <DatePicker
                selected={values.date_acquired}
                maxDate={new Date()}
                showDisabledMonthNavigation
                dateFormat="MMMM d, yyyy"
                className="form-control"
                name="date_acquired"
                onChange={(date) => setFieldValue("date_acquired", date)}
                required
              />{" "}
            </div>

            <div className="form-group">
              <label>
                Office <span className="text-danger"> * </span>
              </label>
              <select
                type="text"
                className="form-control"
                name="office_id"
                onChange={handleChange}
                value={values.office_id}
                required
              >
                <option value="">--Select Office--</option>

                {offices.map((office, i) => (
                  <option value={office.id} key={i}>
                    {office.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>
                Beneficiary <span className="text-danger"> * </span>{" "}
              </label>
              <select
                type="text"
                onChange={handleChange}
                className="form-control"
                name="user_id"
                value={values.user_id}
                required
              >
                <option value="">--Select Benficiary--</option>
                {values.office_id.toString() === "1"
                  ? frontOfficeUser.map((user, i) => (
                      <option value={user.id} key={i}>
                        {user.first_name}
                      </option>
                    ))
                  : values.office_id.toString() === "2"
                  ? middleOfficeUser.map((user, i) => (
                      <option value={user.id} key={i}>
                        {user.first_name}
                      </option>
                    ))
                  : values.office_id.toString() === "3"
                  ? backOfficeUsers.map((user, i) => (
                      <option value={user.id} key={i}>
                        {user.first_name}
                      </option>
                    ))
                  : null}
              </select>
            </div>
            <div className="form-group">
              <label> Price</label>
              <Field
                type="text"
                className="form-control"
                id="price"
                name="price"
                placeholder="Price"
                autoComplete="off"
              />
            </div>

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/organizationmanagement/modal/edit_asset.js